__turbopack_context__.v({
  "clickable": "Table-module__38kp_a__clickable",
  "container": "Table-module__38kp_a__container",
  "loading": "Table-module__38kp_a__loading",
  "pagination": "Table-module__38kp_a__pagination",
  "sortIcon": "Table-module__38kp_a__sortIcon",
  "table": "Table-module__38kp_a__table",
  "td": "Table-module__38kp_a__td",
  "th": "Table-module__38kp_a__th",
  "thead": "Table-module__38kp_a__thead",
  "tr": "Table-module__38kp_a__tr",
});
